import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAP9rEg9Jgt8tjAPI6VzQPEas5LZFL6YmU",
  authDomain: "roamtheworld-316bb.firebaseapp.com",
  projectId: "roamtheworld-316bb",
  storageBucket: "roamtheworld-316bb.firebasestorage.app",
  messagingSenderId: "622422965859",
  appId: "1:622422965859:web:c6b9913dee1f7cd5820256",
  measurementId: "G-01HFCXHV83"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;